/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Alert from "@mui/material/Alert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  AlertTitle,
  Autocomplete,
  FormHelperText,
  IconButton,
  InputAdornment,
  Snackbar,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PercentIcon from "@mui/icons-material/Percent";
import Box from "@mui/material/Box";
import { Stack } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import { advertisingAccountsEndPointLogic } from "../../../../logic/PaidTrafficManagement/AdvertisingAccounts/AdvertisingAccounts/advertisingAccountsEndPointLogic";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import Grid from "@mui/material/Grid";
import "../../PaidTraffic.css";
import store from "../../../../store";
import {
  selectUserData,
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../features/userSlice";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { useDispatch } from "react-redux";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/en-gb"; // Import the locale for British English
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale("en-gb"); // Set the locale globally (optional)

interface EditAccountDialogProps {
  open: any;
  singleAccountShareUID: any;
  oauthTokenHeader: string;
  rowId: string;
  onClose: any;
  singleAdAccountData: any;
  setSingleAdAccountData: any;
  setReloadAfterToggleEdit: any;
  setIsEditBtnEnabled: any;
  accountUpdateError: any;
  setAccountUpdateError: any;
  fetchAdAccountData: any;
  setTrafficSourceData: any;
  getAdAccountDetailsForEdit: Function;
  setRowId: any;
  setrowIndexNumber: any;
  setIsCheckboxCheckedArray: any;
  setEditDialogOpen: any;
  siteNames: any;
  postWebsiteToAcc: Function;
  setAccountUpdateStatus: any;
  accountUpdateStatus: any;
}

interface convActions {
  id: string;
  action: string;
}
interface DateRangeError {
  hasError: boolean;
  message: string;
}

const EditAccountDialog: FC<EditAccountDialogProps> = ({
  singleAccountShareUID,
  setAccountUpdateStatus,
  siteNames,
  fetchAdAccountData,
  setAccountUpdateError,
  accountUpdateError,
  setIsEditBtnEnabled,
  open,
  onClose,
  oauthTokenHeader,
}) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [alertType /* , setAlertType */] = useState("info");
  const [autocompleteList, setAutocompleteList] = useState([]) as any; // Initialize with an empty array
  const [showAlert, setShowAlert] = useState(false);
  const [taxationAmount, setTaxationAmount] = useState(0.0) as any;
  const [singleAdvertisingAccountContent, setSingleAdvertisingAccountContent] =
    useState<any[]>([]);
  const [geoSelected, setGeoSelected] = useState("");
  const [industrySelected, setIndustrySelected] = useState("");
  const [adAccountGeoDetails, setAdAccountGeoDetails] = useState([]);
  const [adAccountIndustryDetails, setAdAccountIndustryDetails] = useState([]);
  const [, setAdAccountTerritoryDetails] = useState([]);
  const [, setAdvertisingAccountToggleContent] = useState([]);
  const [isAccountUpdated, setIsAccountUpdated] = useState(false);
  const [isInputMissing, setIsInputMissing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [linkedAssets, setLinkedAssets] = useState<any[]>([]);
  const [, setAdAccountDetails] = useState([]) as any;
  const [, setErrorAccToPageStatus] = useState(false);
  const [, setAssetType] = useState("");
  const [, setSelectedWebsite] = useState("");
  const [, setSelectedStartDate] = useState<Dayjs | null>(null);
  const [, setSelectedEndDate] = useState<Dayjs | null>(null);
  const [newDataFields, setNewDataFields] = useState([]) as any;
  const [trafficSources, setTrafficSources] = useState([]) as any;
  const [isLoadingApi, setIsLoadingApi] = useState(false);
  const dispatch = useDispatch();
  // const [errorAlert , setErrorAlert] =useState<string | null>(null);
  const [isAddNewClicked, setIsAddNewClicked] = useState(false);
  const [loaderForEdit, setLoaderForEdit] = useState(false);
  const [initialValues, setInitialValues] = useState<any>({});
  const [initialAssetsValues, setInitialAssetsValues] = useState<any>([]);
  const [initialLinkedAssetsCount, setInitialLinkedAssetsCount] = useState(0);
  const [linkedAssetErrors, setLinkedAssetErrors] = useState<DateRangeError[]>(
    [],
  );
  const [newFieldErrors, setNewFieldErrors] = useState<DateRangeError[]>([]);
  const [, setIsError] = useState(false);
  const response = useSelector(selectUserData);
  const hasEditAdAccountPermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "advertising_accounts",
    "edit_ads_account",
  );
  const doRangesOverlap = (range1: any, range2: any) => {
    const start1 = dayjs(range1.start);
    const end1 = dayjs(range1.end);
    const start2 = dayjs(range2.start);
    const end2 = dayjs(range2.end);

    // Check if ranges are valid
    if (
      !start1.isValid() ||
      !end1.isValid() ||
      !start2.isValid() ||
      !end2.isValid()
    ) {
      return false;
    }

    // Two ranges overlap if: start1 <= end2 && start2 <= end1
    return start1.isSameOrBefore(end2) && start2.isSameOrBefore(end1);
  };

  const validateDateRanges = () => {
    const linkedErrors: DateRangeError[] = [];
    const newErrors: DateRangeError[] = [];

    // Get all ranges for comparison
    const allRanges: Array<{
      start: string;
      end: string;
      index: number;
      isNew: boolean;
    }> = [];

    // Add linked assets ranges
    linkedAssets.forEach((asset, index) => {
      if (asset.start_date && asset.end_date) {
        allRanges.push({
          start: asset.start_date,
          end: asset.end_date,
          index,
          isNew: false,
        });
      }
    });

    // Add new data fields ranges
    newDataFields.forEach((field: any, index: number) => {
      if (field.startDate && field.endDate) {
        allRanges.push({
          start: field.startDate,
          end: field.endDate,
          index,
          isNew: true,
        });
      }
    });

    // Find all overlapping ranges
    const overlappingIndices = new Set<string>();

    for (let i = 0; i < allRanges.length; i++) {
      for (let j = i + 1; j < allRanges.length; j++) {
        if (
          doRangesOverlap(
            { start: allRanges[i].start, end: allRanges[i].end },
            { start: allRanges[j].start, end: allRanges[j].end },
          )
        ) {
          // Mark both ranges as having overlaps
          overlappingIndices.add(`${allRanges[i].isNew}-${allRanges[i].index}`);
          overlappingIndices.add(`${allRanges[j].isNew}-${allRanges[j].index}`);
        }
      }
    }

    // Set error states based on overlapping indices
    allRanges.forEach((range) => {
      const key = `${range.isNew}-${range.index}`;
      const hasOverlap = overlappingIndices.has(key);
      const errorMessage = hasOverlap
        ? "Date range overlaps with another asset"
        : "";

      if (range.isNew) {
        newErrors[range.index] = {
          hasError: hasOverlap,
          message: errorMessage,
        };
      } else {
        linkedErrors[range.index] = {
          hasError: hasOverlap,
          message: errorMessage,
        };
      }
    });

    // Fill in missing entries with no error state
    for (let i = 0; i < linkedAssets.length; i++) {
      if (!linkedErrors[i]) {
        linkedErrors[i] = { hasError: false, message: "" };
      }
    }

    for (let i = 0; i < newDataFields.length; i++) {
      if (!newErrors[i]) {
        newErrors[i] = { hasError: false, message: "" };
      }
    }

    setLinkedAssetErrors(linkedErrors);
    setNewFieldErrors(newErrors);
  };

  useEffect(() => {
    if (siteNames && siteNames.length > 0) {
      validateDateRanges();
    }
  }, [linkedAssets, newDataFields, siteNames]);
  const handleAddNewField = () => {
    setNewDataFields((prevFields: any) => [
      ...prevFields,
      {
        assetType: "website",
        website: "",
        startDate: null,
        endDate: null,
      },
    ]);
    setIsAddNewClicked(true);
  };

  //-- Check for start date before end date ranges
  const isIndividualDateInvalid = (
    startDate: Dayjs | null,
    endDate: Dayjs | null,
  ) => {
    if (!startDate || !endDate) return false;
    return dayjs(endDate).isBefore(dayjs(startDate), "day");
  };
  const hasDateRangeOverlaps = () => {
    return (
      linkedAssetErrors.some((error) => error.hasError) ||
      newFieldErrors.some((error) => error.hasError)
    );
  };
  useEffect(() => {
    if (
      singleAdvertisingAccountContent &&
      singleAdvertisingAccountContent[0]?.linked_assets
    ) {
      setLinkedAssets(singleAdvertisingAccountContent[0].linked_assets);
      setInitialLinkedAssetsCount(
        singleAdvertisingAccountContent[0].linked_assets.length,
      );
    }
  }, [singleAdvertisingAccountContent]);

  const handleDisagree = (): void => {
    onClose();
    setNewDataFields([]);
  };

  const [switchChecked, setSwitchChecked] = useState(false);
  useEffect(() => {
    setSwitchChecked(singleAdvertisingAccountContent?.[0]?.active === true);
  }, [setSingleAdvertisingAccountContent]);

  const handleSwitchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isActive = event.target.checked;
    try {
      setStatusLoading(true);
      setSwitchChecked(isActive);
      await toggle();
      await fetchAdAccountData();
      setIsEditBtnEnabled(true);
    } catch (error) {
      console.error("Error toggling account status.");
    } finally {
      setStatusLoading(false);
    }
  };

  useEffect(() => {
    async function getGeo() {
      try {
        if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
          await advertisingAccountsEndPointLogic.getGeo(
            setAdAccountGeoDetails,
            oauthTokenHeader,
          );
        } else {
          throw new Error("Error fetching geo details");
        }
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      }
    }
    async function getIndustries() {
      try {
        if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
          await advertisingAccountsEndPointLogic.getIndustry(
            setAdAccountIndustryDetails,
            oauthTokenHeader,
          );
        } else {
          throw new Error("Error fetching industry details");
        }
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      }
    }
    async function getTerritories() {
      try {
        if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
          await advertisingAccountsEndPointLogic.getTerritory(
            setAdAccountTerritoryDetails,
            oauthTokenHeader,
          );
        } else {
          throw new Error("Error fetching territory details");
        }
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      }
    }

    //Here I Changed
    async function getTrafficSources() {
      try {
        if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
          await advertisingAccountsEndPointLogic.getTrafficSource(
            oauthTokenHeader,
            setTrafficSources,
          );
        } else {
          throw new Error("Error fetching territory details");
        }
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      }
    }

    if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
      getGeo();
      getIndustries();
      getTerritories();
      getTrafficSources();
    }
  }, [oauthTokenHeader, singleAccountShareUID]);

  const trafficSourceName =
    singleAdvertisingAccountContent?.[0]?.traffic_source;
  const matchingSource = trafficSources.find(
    (source: any) => source.traffic_source_name === trafficSourceName,
  );
  const selectedTrafficSourceSharedUid = matchingSource?.shared_uid;

  const toggle = async () => {
    const toggleData = "";
    try {
      await advertisingAccountsEndPointLogic.advertisingAccountsToggle(
        oauthTokenHeader,
        setAdvertisingAccountToggleContent,
        toggleData,
        singleAccountShareUID,
      );
      setSnackbarOpen(true);
      setSnackbarMessage(
        !switchChecked ? "Sync Data Enabled" : "Sync Data Disabled",
      );
    } catch (error) {
      console.error("Error fetching advertising accounts:", error);
    }
  };

  const handleAddButtonClick = () => {
    setTaxationAmount((prevAmount: any) => {
      // Convert prevAmount to number, handling all possible cases
      let currentAmount = 0;

      if (typeof prevAmount === "number" && !isNaN(prevAmount)) {
        currentAmount = prevAmount;
      } else if (typeof prevAmount === "string" && prevAmount !== "") {
        const parsed = parseFloat(prevAmount);
        currentAmount = !isNaN(parsed) ? parsed : 0;
      }
      // If prevAmount is null, undefined, empty string, or NaN, currentAmount stays 0

      const newAmount = currentAmount + 0.1;
      return parseFloat(newAmount.toFixed(2));
    });
  };

  const handleMinusButtonClick = () => {
    setTaxationAmount((prevAmount: any) => {
      // Convert prevAmount to number, handling all possible cases
      let currentAmount = 0;

      if (typeof prevAmount === "number" && !isNaN(prevAmount)) {
        currentAmount = prevAmount;
      } else if (typeof prevAmount === "string" && prevAmount !== "") {
        const parsed = parseFloat(prevAmount);
        currentAmount = !isNaN(parsed) ? parsed : 0;
      }
      // If prevAmount is null, undefined, empty string, or NaN, currentAmount stays 0

      const newAmount = Math.max(0, currentAmount - 0.1); // Prevent negative values
      return parseFloat(newAmount.toFixed(2));
    });
  };
  const fetchSingleAdvertisingAccountData = async () => {
    setLoading(true); // Set loading to true when fetching data
    try {
      if (open) {
        await advertisingAccountsEndPointLogic.getSingleAdvertisingAccount(
          oauthTokenHeader,
          setSingleAdvertisingAccountContent,
          setErrorAccToPageStatus,
          singleAccountShareUID,
          dispatch,
        );
      } else {
        throw new Error("Error fetching advertising accounts");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Set loading to false when data is fetched
    }
  };
  useEffect(() => {
    if (singleAccountShareUID !== null && singleAccountShareUID !== "") {
      fetchSingleAdvertisingAccountData();
    }
  }, [oauthTokenHeader, open, singleAccountShareUID, dispatch]);

  useEffect(() => {
    if (singleAdvertisingAccountContent) {
      setGeoSelected(singleAdvertisingAccountContent?.[0]?.geo);
      setIndustrySelected(singleAdvertisingAccountContent?.[0]?.industry);
      setTaxationAmount(
        singleAdvertisingAccountContent?.[0]?.account_taxation ?? 0.0,
      );

      // Store initial values
      setInitialValues({
        geo: singleAdvertisingAccountContent?.[0]?.geo,
        industry: singleAdvertisingAccountContent?.[0]?.industry,
        taxationAmount:
          singleAdvertisingAccountContent?.[0]?.account_taxation ?? 0.0,
      });
    }
  }, [singleAdvertisingAccountContent]);

  const updateAdAccount = async () => {
    store.dispatch(setIsLoading(true));
    const data = {
      geo: `${
        geoSelected ? geoSelected : singleAdvertisingAccountContent?.[0]?.geo
      }`,
      industry: `${
        industrySelected
          ? industrySelected
          : singleAdvertisingAccountContent?.[0]?.industry
      }`,
      traffic_source: `${singleAdvertisingAccountContent?.[0]?.traffic_source}`,
      account_taxation: Number(taxationAmount),
      advertising_company_shared_uid:
        singleAdvertisingAccountContent?.[0]?.company_shared_uid,
    };
    try {
      const response = await advertisingAccountsEndPointLogic.updateAdAccount(
        singleAccountShareUID,
        data,
        setAccountUpdateStatus,
        setAccountUpdateError,
        oauthTokenHeader,
        dispatch,
      );
      //setSnackbarOpen(true);
      // setSnackbarMessage("Account Updated successfully");
      return response;
    } catch (error) {
      console.error("Error updating ad account:", error);
    }
  };

  const updateAssetLinks = async () => {
    const data = {
      data: {
        sites: linkedAssets.map((asset: any) => ({
          website_shared_uid: asset.websites__shared_uid,
          start_date: asset.start_date && asset.start_date, // Format the start_date to YYYY-MM-DD
          end_date: asset.end_date && asset.end_date, // Format the end_date to YYYY-MM-DD
        })),
      },
    };
    if (!data.data.sites.length) return;
    try {
      const res = await advertisingAccountsEndPointLogic.updateAssetLinks(
        oauthTokenHeader,
        data,
        singleAccountShareUID,
        dispatch,
        setIsError,
      );
      setSnackbarOpen(true);
      setSnackbarMessage("Linked Aseets Updated Successfully");
      return res;
    } catch (error) {
      console.error("Error updating asset links:", error);
    }
  };

  useEffect(() => {
    if (
      singleAdvertisingAccountContent &&
      singleAdvertisingAccountContent[0]?.linked_assets
    ) {
      setLinkedAssets(singleAdvertisingAccountContent[0].linked_assets);
    }
  }, [singleAdvertisingAccountContent]);

  const handleAlertClose = () => {
    setShowAlert(false); // Close the alert
  };

  useEffect(() => {
    // Check if singleAdvertisingAccountContent and its properties exist
    if (
      singleAdvertisingAccountContent &&
      singleAdvertisingAccountContent[0]?.linked_assets
    ) {
      const newList = singleAdvertisingAccountContent?.[0]?.linked_assets?.map(
        (asset: any, index: number) => ({
          id: index + 1,
          assetType: "website",
          assetName: asset.websites__site_name,
          startDate: new Date(asset.start_date),
          endDate: new Date(asset.end_date),
          // disabled: true, // Mark existing assets as disabled
        }),
      );

      setAutocompleteList(newList); // Update the state with the new list
      setInitialAssetsValues(newList);
    } else {
      setAutocompleteList([]); // Reset to an empty array if data is not available
    }
  }, [singleAdvertisingAccountContent]); // Dependency array to run effect when singleAdvertisingAccountContent changes

  const handleAssetChange = (index: any, field: string, value: any) => {
    const newList = [...autocompleteList];
    newList[index][field] = value;
    setAutocompleteList(newList);
  };

  //-- check If Account data is changed Or Not
  const hasChanges = () => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      return false; // Initial values not set yet
    }

    return (
      geoSelected !== initialValues.geo ||
      industrySelected !== initialValues.industry ||
      parseFloat(taxationAmount) !== parseFloat(initialValues.taxationAmount)
    );
  };

  //-- check If Existing Assets data is changed
  const hasChangeAssetsLinks = () => {
    // if (linkedAssets.length !== initialAssetsValues.length) {
    //   return true; // Different lengths mean changes
    // }

    return linkedAssets.some((asset, index) => {
      const initialAsset = initialAssetsValues[index];
      return (
        //asset.assetType !== initialAsset.assetType ||
        asset.websites__site_name !== initialAsset.assetName ||
        asset.start_date !==
          new Date(initialAsset.startDate).toISOString().split("T")[0] ||
        asset.end_date !==
          new Date(initialAsset.endDate).toISOString().split("T")[0]
      );
    });
  };

  //-- Check same account or not
  const checkSameAccount = () => {
    return newDataFields.some((field: any) =>
      linkedAssets.some((asset) => asset.websites__site_name === field.website),
    );
  };
  const postAcc = async () => {
    const data = {
      data: {
        sites: newDataFields.map((field: any) => ({
          website_shared_uid: field.website, // Use the website from the newDataFields
          start_date: field.startDate && field.startDate, // Format the start date to YYYY-MM-DD
          end_date: field.endDate && field.endDate, // Format the end date to YYYY-MM-DD
        })),
      },
    };
    if (!data.data.sites.length) return;

    const res = await advertisingAccountsEndPointLogic.postWebToAcc(
      oauthTokenHeader,
      data,
      singleAdvertisingAccountContent?.[0]?.shared_uid,
    );

    return res;
  };

  const handleAgree = async () => {
    if (checkSameAccount()) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Account already linked.",
          type: "error",
        }),
      );
      return;
    }

    try {
      setLoaderForEdit(true);
      const statuses: any = [];
      if (hasChangeAssetsLinks()) {
        const res = await updateAssetLinks();
        statuses.push(res?.status);
      }
      //-- check Add New button Clicked
      if (isAddNewClicked) {
        const res = await postAcc();
        statuses.push(res?.status);
      } else {
        setIsAddNewClicked(false);
      }
      setAssetType("");
      setSelectedWebsite("");
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      if (oauthTokenHeader) {
        if (hasChanges()) {
          const res = await updateAdAccount();
          statuses.push(res?.status);
        }
        const allSuccess =
          statuses.length > 0 && statuses.every((code: any) => code === 200);
        if (allSuccess) {
          await fetchAdAccountData();
        } else {
          console.warn(
            "One or more API calls failed. Skipping fetchAdAccountData.",
          );
        }
      } else {
        throw new Error("Input missing");
      }
    } catch (error) {
      console.error("Error updating ad account:", error);
    } finally {
      setSnackbarOpen(false);
      setSnackbarMessage("");
      setDisplayErrorSnackBar(false);
      setIsAccountUpdated(false);
      setNewDataFields([]);
      setLoaderForEdit(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAccountUpdateError(false);
    }, 3000); // 3000 ms = 3 seconds
    return () => clearTimeout(timer); // Clear the timeout if the component unmounts
  }, [accountUpdateError, setAccountUpdateError]);

  useEffect(() => {
    if (isInputMissing) {
      setIsInputMissing(true);
      const timer = setTimeout(() => {
        setIsInputMissing(false);
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // Clear the timeout if the component unmounts
    }
  }, [isInputMissing]);

  const dialogContentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Reset scroll position on component mount or dialog open
    if (dialogContentRef?.current) {
      dialogContentRef.current.scrollTop = 0;
    }
    if (isInputMissing && dialogContentRef?.current) {
      dialogContentRef?.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isInputMissing]);

  const handleInputChange = (event: any) => {
    const value = event.target.value;

    if (value === "") {
      setTaxationAmount(0.0);
      return;
    }

    // Allow partial decimal input (e.g., "5.", "5.1", ".5")
    // Only validate if it's a valid number pattern
    const decimalPattern = /^-?\d*\.?\d*$/;

    if (decimalPattern.test(value)) {
      // If it ends with just a decimal point, keep the string for display
      if (value.endsWith(".") || value === "-") {
        setTaxationAmount(value);
      } else {
        const parsedValue = parseFloat(value);
        if (!isNaN(parsedValue)) {
          setTaxationAmount(parsedValue);
        }
      }
    }
  };

  const handleInputBlur = (event: any) => {
    const value = event.target.value;
    if (value === "" || value === "." || value === "-") {
      setTaxationAmount(0.0);
    } else {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        setTaxationAmount(parsedValue);
      } else {
        setTaxationAmount(0.0);
      }
    }
  };

  const geoDropDown =
    adAccountGeoDetails && adAccountGeoDetails?.map((a: any) => a.name);
  const getFilteredSiteNames = (currentIndex = null, isNewField = false) => {
    if (!siteNames) return [];

    // Get all selected website keys from existing linked assets
    const selectedFromLinkedAssets = linkedAssets
      .map((asset) => asset.websites__shared_uid)
      .filter(Boolean);

    // Get all selected website keys from new data fields
    const selectedFromNewFields = newDataFields
      .map((field: any) => field.website)
      .filter(Boolean);

    // Combine all selected websites
    const allSelectedWebsites = [
      ...selectedFromLinkedAssets,
      ...selectedFromNewFields,
    ];

    // If we're editing a specific field, exclude its current value from the "already selected" list
    if (currentIndex !== null) {
      if (isNewField) {
        // For new fields, remove the current field's selection from the exclusion list
        const currentSelection = newDataFields[currentIndex]?.website;
        if (currentSelection) {
          const indexToRemove =
            allSelectedWebsites.lastIndexOf(currentSelection);
          if (indexToRemove > -1) {
            allSelectedWebsites.splice(indexToRemove, 1);
          }
        }
      } else {
        // For existing linked assets, remove the current asset's selection from the exclusion list
        const currentSelection =
          linkedAssets[currentIndex]?.websites__shared_uid;
        if (currentSelection) {
          const indexToRemove = allSelectedWebsites.indexOf(currentSelection);
          if (indexToRemove > -1) {
            allSelectedWebsites.splice(indexToRemove, 1);
          }
        }
      }
    }

    // Filter out already selected websites
    return siteNames.filter(
      (site: any) => !allSelectedWebsites.includes(site.key),
    );
  };

  // const territoryDropDown = adAccountTerritoryDetails && adAccountTerritoryDetails?.map((a: any) => a.territory_name);
  const industryDropDown =
    adAccountIndustryDetails &&
    adAccountIndustryDetails?.map((a: any) => a.industry_name);

  //Here I Changed
  const getAdAccountDetailsForEdit = async () => {
    setIsLoadingApi(true); // Set loading to true when the API call starts
    store.dispatch(setIsLoading(true));

    try {
      // First API call to get account details
      const accountDetails: any =
        await advertisingAccountsEndPointLogic.getAdAccountDetails(
          oauthTokenHeader,
          selectedTrafficSourceSharedUid,
          singleAdvertisingAccountContent?.[0]?.account_id,
          setIsLoading,
          setAdAccountDetails,
          singleAdvertisingAccountContent?.[0]?.company_shared_uid,
        );

      // Check if accountDetails is defined and has the expected structure
      if (!accountDetails || !accountDetails?.data?.account_conv_actions) {
        throw new Error(
          "Account details are not available or do not contain account_conv_actions.",
        );
      }

      // Destructure the necessary data from the response
      const { account_conv_actions } = accountDetails?.data;

      // Prepare data for the post request
      await advertisingAccountsEndPointLogic.postAdAccountDetails(
        oauthTokenHeader,
        { conversion_actions: account_conv_actions }, // Pass the new conversion actions
        singleAdvertisingAccountContent?.[0]?.shared_uid,
      );
      // Update the state directly instead of making another GET request/
      await advertisingAccountsEndPointLogic.getSingleAdvertisingAccount(
        oauthTokenHeader,
        setSingleAdvertisingAccountContent,
        setErrorAccToPageStatus,
        singleAccountShareUID, // Assuming this is the rowId you want to use
        dispatch,
      );
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Ad Account Details Fetched Successfully",
          type: "success",
        }),
      );
    } catch (error) {
      console.error("Error fetching advertising accounts:", error);
    } finally {
      setIsLoadingApi(false); // Set loading to false when the API call is complete
      store.dispatch(setIsLoading(false));
    }
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity="success"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };
  const handleRemove = (indexToRemove: number) => {
    setNewDataFields((prevDivs: any) =>
      prevDivs.filter((_: any, i: any) => i !== indexToRemove),
    );
  };
  const handleRemoveLinkedAsset = (indexToRemove: number) => {
    setLinkedAssets((prevAssets) =>
      prevAssets.filter((_, i) => i !== indexToRemove),
    );
  };

  const isFormValid = () => {
    // Check if required account fields are filled
    const hasGeo = geoSelected;
    const hasIndustry = industrySelected;
    const hasTaxation = taxationAmount !== null && taxationAmount !== undefined;

    // Check if existing linked assets have required fields
    const existingAssetsValid = linkedAssets.every((asset) => {
      return (
        asset.websites__site_name &&
        asset.start_date &&
        asset.end_date &&
        dayjs(asset.start_date).isValid() &&
        dayjs(asset.end_date).isValid() &&
        !isIndividualDateInvalid(dayjs(asset.start_date), dayjs(asset.end_date))
      );
    });
    // Check if new data fields have required fields (if any)
    const newFieldsValid =
      newDataFields.length === 0 ||
      newDataFields.every((field: any) => {
        return (
          field.assetType &&
          field.website &&
          field.startDate &&
          field.endDate &&
          dayjs(field.startDate).isValid() &&
          dayjs(field.endDate).isValid() &&
          !isIndividualDateInvalid(dayjs(field.startDate), dayjs(field.endDate))
        );
      });
    const noOverlaps = !hasDateRangeOverlaps();
    return (
      hasGeo &&
      hasIndustry &&
      hasTaxation &&
      existingAssetsValid &&
      newFieldsValid &&
      noOverlaps
    );
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {snackbarOpen && renderSnackbar()}
          <Dialog
            ref={dialogContentRef}
            sx={{ overflowY: "auto" }}
            maxWidth="md"
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleDisagree();
              }
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Edit Account"}
            </DialogTitle>
            <DialogContent sx={{ overflowY: "auto" }}>
              <DialogContentText>
                {isInputMissing && (
                  <Alert
                    sx={{
                      height: "50%",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      padding: "0 4px",
                    }}
                    severity="warning"
                  >
                    Input missing, Please try again!
                  </Alert>
                )}
                {accountUpdateError && (
                  <Alert
                    sx={{
                      height: "50%",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      padding: "0 4px",
                    }}
                    severity="error"
                  >
                    Account Updation failed.
                  </Alert>
                )}
                {showAlert && (
                  <Alert
                    iconMapping={{
                      success: (
                        <CheckCircleOutlineIcon
                          sx={{
                            color:
                              alertType === "error" ? "#5F2120" : "#1E4620",
                          }}
                        />
                      ),
                    }}
                    onClose={handleAlertClose}
                    sx={{
                      backgroundColor:
                        alertType === "error" ? "#FDEDED" : "#EDF7ED",
                      color: alertType === "error" ? "#5F2120" : "#1E4620",
                      border:
                        alertType === "error"
                          ? "1px solid #D32F2F80"
                          : "1px solid #2E7D3280",
                      height: "50%",
                      fontWeight: "500",
                    }}
                  >
                    <AlertTitle>
                      {alertType === "success"
                        ? "Account retrieved successfully!"
                        : "Unable to retrieve account, please check the Account name and Source and try again."}
                    </AlertTitle>
                  </Alert>
                )}
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "16px",
                    paddingTop: "16px",
                    gap: "16px",
                  }}
                >
                  <TextField
                    disabled
                    id="outlined-disabled"
                    label="Source"
                    value={
                      singleAdvertisingAccountContent?.[0]?.traffic_source ? (
                        singleAdvertisingAccountContent?.[0]?.traffic_source
                      ) : (
                        <Box sx={{ display: "flex" }}>
                          <CircularProgress />
                        </Box>
                      )
                    }
                    size="small"
                    sx={{ width: "50%", background: "#0000000F" }}
                  />
                  <TextField
                    disabled
                    id="outlined-disabled"
                    label="ID at source"
                    value={singleAdvertisingAccountContent?.[0]?.account_id}
                    size="small"
                    sx={{ width: "50%", background: "#0000000F" }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "16px",
                    gap: "16px",
                  }}
                >
                  <TextField
                    disabled
                    id="outlined-disabled"
                    label="Account Name"
                    value={singleAdvertisingAccountContent?.[0]?.account_name}
                    size="small"
                    sx={{ width: "49%", background: "#0000000F" }}
                  />
                  <TextField
                    id="outlined-disabled"
                    size="small"
                    sx={{ width: "318px" }}
                    color="secondary"
                    label="Taxation"
                    value={taxationAmount}
                    onBlur={handleInputBlur}
                    onChange={handleInputChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PercentIcon sx={{ marginLeft: "12px" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <AddIcon
                    onClick={handleAddButtonClick}
                    cursor="pointer"
                    color="secondary"
                    sx={{ marginLeft: "5px", marginTop: "6px" }}
                  />
                  <RemoveIcon
                    onClick={handleMinusButtonClick}
                    cursor="pointer"
                    color="secondary"
                    sx={{ marginLeft: "5px", marginTop: "6px" }}
                  />
                </div>
                <div style={{ display: "flex", paddingBottom: "16px" }}>
                  <div>
                    <Autocomplete
                      options={geoDropDown}
                      value={geoSelected ? geoSelected : null} // Set to null if no geo is selected
                      onChange={(_, newValue: any) => {
                        setGeoSelected(newValue || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Geo *"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon sx={{ marginLeft: "12px" }} />
                              </InputAdornment>
                            ),
                          }}
                          color="secondary"
                        />
                      )}
                      size="small"
                      sx={{ width: "430px", paddingRight: "16px" }}
                    />
                  </div>
                  <div>
                    <Autocomplete
                      options={industryDropDown}
                      value={industrySelected ? industrySelected : null} // Set to null if no industry is selected
                      onChange={(_, newValue: any) => {
                        setIndustrySelected(newValue || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Industry *"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start"></InputAdornment>
                            ),
                          }}
                          color="secondary"
                        />
                      )}
                      size="small"
                      sx={{ width: "418px" }}
                    />
                  </div>
                </div>
                <FormHelperText sx={{ marginBlock: "16px" }}>
                  All fields are mandatory.
                </FormHelperText>
                <FormHelperText
                  sx={{
                    marginBlock: "16px",
                    fontSize: "16px",
                    color: "#000000",
                  }}
                >
                  Linked Asset{" "}
                </FormHelperText>
                <Grid container spacing={2}>
                  {linkedAssets.map((asset, index: any) => (
                    <Grid item xs={12} key={asset.websites__shared_uid}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Autocomplete
                            disabled={true}
                            options={["website"]}
                            defaultValue={"website"}
                            onChange={(_, newValue) =>
                              handleAssetChange(
                                index,
                                "assetType",
                                newValue || "",
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Asset type"
                                placeholder="Select type from the list."
                                color="secondary"
                              />
                            )}
                            size="small"
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Autocomplete
                            options={getFilteredSiteNames(index, false)}
                            disabled={true}
                            getOptionLabel={(option: any) =>
                              option.site?.ui_site_name || ""
                            }
                            value={
                              siteNames?.find(
                                (site: any) =>
                                  site.key === asset.websites__shared_uid,
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              const updatedAssets = [...linkedAssets];
                              updatedAssets[index].websites__site_name =
                                newValue?.key || "";
                              setLinkedAssets(updatedAssets);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Website"
                                size="small"
                                color="secondary"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateRangePicker
                              slots={{ field: SingleInputDateRangeField }}
                              name="allowedRange"
                              slotProps={{
                                textField: {
                                  size: "small",
                                  fullWidth: true,
                                  color: "secondary",
                                  // NEW: Apply error styling if there's an overlap
                                  error:
                                    linkedAssetErrors[index]?.hasError ||
                                    isIndividualDateInvalid(
                                      dayjs(asset.start_date),
                                      dayjs(asset.end_date),
                                    ),
                                  helperText:
                                    linkedAssetErrors[index]?.message ||
                                    (isIndividualDateInvalid(
                                      dayjs(asset.start_date),
                                      dayjs(asset.end_date),
                                    )
                                      ? "End date cannot be before start date"
                                      : ""),
                                  FormHelperTextProps: {
                                    sx: {
                                      fontSize: "0.73rem",
                                      margin: "0px !important",
                                    },
                                  },
                                  sx: {
                                    // Additional styling for error state
                                    "& .MuiOutlinedInput-root": {
                                      "&.Mui-error": {
                                        "& fieldset": {
                                          borderColor: "#d32f2f",
                                        },
                                      },
                                    },
                                  },
                                },
                              }}
                              format="DD-MM-YYYY"
                              value={[
                                dayjs(asset.start_date),
                                dayjs(asset.end_date),
                              ]}
                              onChange={(newValue) => {
                                if (!newValue || !newValue[0] || !newValue[1]) {
                                  console.warn(
                                    "Invalid date range selected:",
                                    newValue,
                                  );
                                  return;
                                }

                                const [startDate, endDate] = newValue;

                                setLinkedAssets((prev) =>
                                  prev.map((item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          start_date:
                                            startDate.format("YYYY-MM-DD"),
                                          end_date:
                                            endDate.format("YYYY-MM-DD"),
                                        }
                                      : item,
                                  ),
                                );
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                        {index >= initialLinkedAssetsCount && (
                          <Grid item xs="auto">
                            <IconButton
                              color="secondary"
                              onClick={() => handleRemoveLinkedAsset(index)}
                              sx={{ marginTop: "-4px" }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
                {/* Add New Data Start */}
                {newDataFields.map((field: any, index: any) => (
                  <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: "16px" }}
                    key={index}
                  >
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        disabled={false}
                        options={["website"]}
                        value={field.assetType || "website"}
                        onChange={(_, newValue) => {
                          const updatedFields = [...newDataFields];
                          updatedFields[index].assetType = newValue || "";
                          setNewDataFields(updatedFields);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Asset type"
                            placeholder="Select type from the list."
                            color="secondary"
                          />
                        )}
                        size="small"
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        options={getFilteredSiteNames(index, true)}
                        disabled={false}
                        getOptionLabel={(option: any) =>
                          option.site?.ui_site_name || ""
                        }
                        value={
                          getFilteredSiteNames().find(
                            // Use unfiltered list to find current value
                            (site: any) => site.key === field.website,
                          ) ||
                          siteNames?.find(
                            (site: any) => site.key === field.website,
                          ) ||
                          null
                        }
                        onChange={(_, newValue) => {
                          const updatedFields = [...newDataFields];
                          updatedFields[index].website = newValue?.key || "";
                          setNewDataFields(updatedFields);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Website"
                            size="small"
                            color="secondary"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateRangePicker
                          slots={{ field: SingleInputDateRangeField }}
                          name="allowedRange"
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              color: "secondary",
                              // NEW: Apply error styling if there's an overlap
                              error:
                                newFieldErrors[index]?.hasError ||
                                isIndividualDateInvalid(
                                  dayjs(field.startDate),
                                  dayjs(field.endDate),
                                ),
                              helperText:
                                newFieldErrors[index]?.message ||
                                (isIndividualDateInvalid(
                                  dayjs(field.startDate),
                                  dayjs(field.endDate),
                                )
                                  ? "End date cannot be before start date"
                                  : ""),
                              FormHelperTextProps: {
                                sx: {
                                  fontSize: "0.73rem",
                                  margin: "0px !important",
                                },
                              },
                              sx: {
                                // Additional styling for error state
                                "& .MuiOutlinedInput-root": {
                                  "&.Mui-error": {
                                    "& fieldset": {
                                      borderColor: "#d32f2f",
                                    },
                                  },
                                },
                              },
                            },
                          }}
                          format="DD-MM-YYYY"
                          value={[dayjs(field.startDate), dayjs(field.endDate)]}
                          onChange={(newValue: any) => {
                            const [startDate, endDate] = newValue || [];

                            // Ensure valid values before proceeding
                            if (!startDate || !endDate) return;

                            const updatedFields = [...newDataFields];
                            updatedFields[index].startDate =
                              startDate.format("YYYY-MM-DD");
                            updatedFields[index].endDate =
                              endDate.format("YYYY-MM-DD");

                            setNewDataFields(updatedFields);
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs="auto">
                      <IconButton
                        color="secondary"
                        onClick={() => handleRemove(index)}
                        sx={{ marginTop: "-4px" }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
                <Stack
                  padding={1}
                  marginY={2}
                  direction="column"
                  alignItems={"start"}
                  spacing={1}
                >
                  <Typography fontSize={12} sx={{ marginBlock: "8px 6px" }}>
                    More than one linked asset?
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={handleAddNewField}
                    color="secondary"
                  >
                    Add New
                  </Button>
                </Stack>
                {/* Add New Data End */}
                <FormControlLabel
                  control={
                    statusLoading ? (
                      <CircularProgress size={24} color="secondary" />
                    ) : (
                      <Switch
                        color="success"
                        checked={
                          singleAdvertisingAccountContent?.[0]?.active === true
                        }
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#2E7D32",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#2E7D32",
                            },
                        }}
                        onChange={handleSwitchChange}
                      />
                    )
                  }
                  sx={{ marginTop: "20px" }}
                  label="Account Status"
                />
                <Snackbar
                  sx={{ top: "100px !important" }}
                  open={snackbarOpen}
                  autoHideDuration={1000}
                  onClose={() => setSnackbarOpen(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={switchChecked ? "success" : "warning"}
                    sx={{ width: "100%", zIndex: "9999999", top: "100px" }}
                  >
                    {snackbarMessage}
                  </Alert>
                </Snackbar>
                <Snackbar
                  sx={{ top: "100px !important" }}
                  open={isAccountUpdated}
                  autoHideDuration={6000}
                  onClose={() => setIsAccountUpdated(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <Alert
                    onClose={() => setIsAccountUpdated(false)}
                    severity="success"
                    sx={{ width: "100%", zIndex: "9999999", top: "100px" }}
                  >
                    {"Account Updated succesfully"}
                  </Alert>
                </Snackbar>
                <Stack
                  padding={1}
                  marginY={2}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <Typography style={{ fontSize: "1rem" }}>
                    Conversion Actions
                  </Typography>
                  {isLoadingApi ? (
                    <CircularProgress size={24} color="secondary" />
                  ) : (
                    <Button
                      onClick={() => getAdAccountDetailsForEdit()}
                      variant="outlined"
                      color="secondary"
                      sx={{
                        border: "none", // Removes the border
                        "&:hover": {
                          border: "none", // Ensures no border on hover as well
                        },
                      }}
                      disabled={isLoadingApi} // Disable the button while loading
                    >
                      {hasEditAdAccountPermission ? (
                        <ReplayOutlinedIcon color="secondary" />
                      ) : (
                        <ReplayOutlinedIcon color="disabled" />
                      )}
                    </Button>
                  )}
                </Stack>
                {singleAdvertisingAccountContent[0]?.conv_actions?.map(
                  (item: convActions) => (
                    <div
                      style={{
                        display: "flex",
                        paddingBottom: "16px",
                        gap: "16px",
                      }}
                    >
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Action name"
                        defaultValue={item?.action}
                        size="small"
                        sx={{ width: "500px", background: "#0000000F" }}
                      />
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Action ID at source"
                        defaultValue={item?.id}
                        size="small"
                        sx={{ width: "325px", background: "#0000000F" }}
                      />
                    </div>
                  ),
                )}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
              <Button
                autoFocus
                disabled={loaderForEdit}
                onClick={handleDisagree}
                sx={{
                  color: "#9C27B0",
                  "&:hover": { background: "#ffffff", color: "#9C27B0" },
                }}
              >
                CANCEL
              </Button>
              <Button
                data-tracker="187"
                variant="outlined"
                onClick={handleAgree}
                disabled={isLoadingApi || loaderForEdit || !isFormValid()}
                endIcon={
                  loaderForEdit ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : null
                }
                autoFocus
                color="secondary"
              >
                {loaderForEdit ? "Saving Changes..." : "Save Changes"}

                <SaveOutlinedIcon
                  sx={{
                    marginLeft: "8px",
                    display: loaderForEdit ? "none" : "inline-flex",
                  }}
                />
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default EditAccountDialog;
